export const SiteStatus = {
    Pending: 'pending',
    Submitted: 'submitted',
    Deployed: 'deployed',
};
